import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import { browserHistory } from 'react-router'
import ContentHeader from 'component/utils/ContentHeader'
import Button from 'component/Button/index'
import FormModal from 'component/ircLists/FormModal'
import Tables from 'component/ircLists/Tables'
import ProcessingModal from 'component/ircLists/ProcessingModal'
import ViewModal from 'component/ircLists/ViewModalNew'
import UploadModal from 'component/ircLists/UploadModal'
import SideFilterForm from 'component/ircLists/SideFilterForm'
import Pagination from 'component/pagination/Pagination'
import FileInput from 'component/FileInput'
import Grid from 'component/utils/Grid'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import SuccessModal from 'component/Modal/SuccessModal'
import DetailedWarningModal from 'component/Modal/DetailedWarningModal'
import DetailedErrorModal from 'component/Modal/DetailedErrorModal'
import * as ircActions from 'action/irc'
import FilterIconSVG from 'component/svgComponents/filter'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

class IrcLists extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    count: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    fetchIrcList: PropTypes.func.isRequired,
    ircList: PropTypes.array.isRequired,
    pages: PropTypes.number.isRequired,
    saveIrcList: PropTypes.func.isRequired,
    deleteIrcList: PropTypes.func.isRequired,
    validateProducts: PropTypes.func.isRequired,
    productsValidation: PropTypes.any,
    isUserMatriz: PropTypes.bool.isRequired,
    user:PropTypes.object
  }

  state = {
    sideFilterVisible: false,
    storeMatriz: '999',
    userMatriz: false,
    currentItem: false,
    csvFile: false,
    showProcessingModal: false,
    showEditModal: false,
    showUploadModal: false,
    successModalMsg: false,
    filterParams: {},
    fileError: false,
    missionsSelectBranchs: [],
    showScheduleBlockWarning: false,
    scheduleBlockMessage: '',
    scheduleBlockMessageHtml: '',
    scheduleBlockType: 'warning',
    showScheduleBlockButton: false,
    scheduleBlockShouldRefresh: true,
    customTitle: null,
    customQuestion: null,
    customButton1Text: null,
    customButton2Text: null,
    showErrorModal: false,
    errorModalData: null,
    scheduleBlockScrollableList: null,
  }

  componentDidMount() {
    const params = {
      dsKey: "missions.select.branchs",
      nuParameter: 1
    }
    this.handleFetchIrcList()
    this.getParameter(params).then(resp => {
      const missions = resp.data.split(",")
      this.setState({missionsSelectBranchs: missions}, () => {
        this.handleFetchIrcList()
      })
    })
  }

  getParameter(values) {
    const {user} = this.props
    return new Api(user.dsToken).get(API_URL.PARAMETER_GET, values)
  }

  handleFetchIrcList = (page = 1) => {
    const {
      auth: { user },
      fetchIrcList,
    } = this.props
    const { filterParams } = this.state
    fetchIrcList(user.dsToken, page, filterParams)
  }

  onSubmit = async (values) => {
    const {
      auth: { user },
      saveIrcList,
      translate,
    } = this.props
    try {
      const result = await saveIrcList(user.dsToken, values)
      if (result && result.blockedBranches && result.blockedBranches.length > 0) {
        const scrollableList = result.blockedBranches.map(branch => `${branch.branchId} - ${branch.branchName}`)
        const successMessage = `<div class="irc-schedule-block-success-message"><strong class="irc-schedule-block-success-title">${  translate('irc.schedule.block.success')  }</strong></div>`
        const detailsText = translate('irc.schedule.block.warning.details')
        const replacedDetails = detailsText.replace('{details}', '')
        const warningMessage = `${successMessage
                              }<div class="irc-schedule-block-warning-message">${  translate('irc.schedule.block.warning.integration')  }</div>${
                              replacedDetails.replace(/\n\n/g, '<br>')}`
        this.setState({
          showScheduleBlockWarning: true,
          scheduleBlockMessage: warningMessage,
          scheduleBlockMessageHtml: warningMessage,
          scheduleBlockType: 'success',
          showScheduleBlockButton: true,
          scheduleBlockShouldRefresh: true,
          csvFile: false,
          scheduleBlockScrollableList: scrollableList,
        })
      } else {
        this.setState({
          successModalMsg: translate('irc.save.success'),
          csvFile: false,
          showScheduleBlockWarning: false,
        })
      }
    } catch (error) {
      let errorMsg = ''
      const allErrorMessages = []
      let scheduleBlockData = null
      if (error && error.fields && error.fields.length > 0) {
        const conflictingLists = []
        const conflictMessages = []
        let hasListConcomitantError = false
        let hasScheduleBlockError = false
        const blockedBranchesList = []
        error.fields.forEach(fieldError => {
          const msg = fieldError.dsDetail || fieldError.dsMessage || ''
          const fieldName = fieldError.naField || ''
          if (fieldName === 'LIST_CONCOMITANT_ERROR') {
            hasListConcomitantError = true
            conflictingLists.push(msg)
            conflictMessages.push(translate('irc.error.list.exists.message'))
          } else if (fieldName === 'SECTION_CONCOMITANT_ERROR') {
            hasListConcomitantError = true
            conflictingLists.push(msg)
            conflictMessages.push(translate('irc.error.section.exists.message'))
          } else if (fieldName === 'scheduleBlock') {
            hasScheduleBlockError = true
            scheduleBlockData = true
            if (msg.includes('SCHEDULE_BLOCK_ALL_STORES')) {
              allErrorMessages.push(translate('irc.schedule.block.error.total'))
              this.setState({ scheduleBlockShouldRefresh: false })
            } else {
              blockedBranchesList.push(msg)
            }
          } else {
            if (msg && (msg.includes('Lista:') || msg.includes('lista') || msg.includes('concomitante'))) {
              hasListConcomitantError = true
              conflictingLists.push(msg)
              conflictMessages.push(translate('irc.error.list.exists.message'))
            } else if (msg) {
              allErrorMessages.push(msg)
            }
          }
        })
        if (hasListConcomitantError) {
          let errorMessage = ''
          let scrollableList = null
          let footerText = null
          if (conflictingLists.length > 0) {
            const extractedLists = []
            conflictingLists.forEach(item => {
              if (item.includes('Lista:')) {
                const listName = item.replace(/.*Lista:\s*/, '').trim()
                if (listName) {
                  extractedLists.push(listName)
                }
              } else {
                extractedLists.push(item)
              }
            })
            const headerKey = extractedLists.length > 1 ? 'irc.error.list.exists.multiple' : 'irc.error.list.exists.single'
            errorMessage = translate(headerKey)
            scrollableList = extractedLists
            footerText = translate('irc.error.list.exists.footer')
          } else {
            errorMessage = conflictMessages[0] || translate('irc.error.list.exists.message')
          }
          this.setState({
            showErrorModal: true,
            errorModalData: {
              title: translate('error'),
              text: translate('irc.error.register.list'),
              details: '',
              reasonText: errorMessage,
              scrollableList,
              footerText
            }
          })
          return
        }
        if (hasScheduleBlockError) {
          let combinedMessage = allErrorMessages.join('\n\n')
          let scrollableList = null
          
          if (blockedBranchesList.length > 0) {
            const detailsText = translate('irc.schedule.block.warning.details')
            combinedMessage = detailsText.replace('{details}', '').trim()
            scrollableList = blockedBranchesList
          }
          
          this.setState({
            showScheduleBlockWarning: true,
            scheduleBlockMessage: combinedMessage,
            scheduleBlockType: 'error',
            showScheduleBlockButton: !!scheduleBlockData,
            scheduleBlockShouldRefresh: this.state.scheduleBlockShouldRefresh !== false,
            customTitle: null,
            customQuestion: null,
            customButton1Text: null,
            customButton2Text: null,
            scheduleBlockScrollableList: scrollableList
          })
          return
        }
        if (allErrorMessages.length > 0) {
          const combinedMessage = allErrorMessages.join('\n\n')
          this.setState({
            showScheduleBlockWarning: true,
            scheduleBlockMessage: combinedMessage,
            scheduleBlockType: 'error',
            showScheduleBlockButton: false,
            scheduleBlockShouldRefresh: true,
            customTitle: null,
            customQuestion: null,
            customButton1Text: null,
            customButton2Text: null
          })
          return
        }
      } else if (error && error.message) {
        if (typeof error.message === 'string') {
          errorMsg = error.message
        } else if (error.message.dsMessage) {
          errorMsg = error.message.dsMessage
        }
      } else if (error && error.data) {
        if (error.data.message) {
          if (typeof error.data.message === 'string') {
            errorMsg = error.data.message
          } else if (error.data.message.dsMessage) {
            errorMsg = error.data.message.dsMessage
          }
        } else if (error.data.dsMessage) {
          errorMsg = error.data.dsMessage
        }
      }
      if (errorMsg) {
        this.setState({
          showScheduleBlockWarning: true,
          scheduleBlockMessage: errorMsg,
          scheduleBlockType: 'error',
          showScheduleBlockButton: false,
          scheduleBlockShouldRefresh: true
        })
        return
      }
      this.setState({
        showErrorModal: true,
        errorModalData: {
          title: translate('error'),
          text: translate('irc.error.process.request'),
          details: '',
          reasonText: error?.message || error?.data?.message || translate('irc.error.unknown')
        }
      })
    }
  }

  handleDelete = async (irc) => {
    const {
      auth: { user },
      deleteIrcList,
      translate,
    } = this.props
    await deleteIrcList(user.dsToken, irc)
    this.setState({ successModalMsg: translate('irc.remove.success') })
  }

  toggleEdit = (show, irc) => {
    this.setState({ showEditModal: show, currentItem: irc })
  }

  renderEditModal() {
    const {
      translate,
      auth: { user },
    } = this.props
    const { currentItem, showEditModal } = this.state
    if (showEditModal) {
      return (
        <FormModal
          translate={translate}
          user={user}
          edit={currentItem}
          onSubmit={this.onSubmit}
          toggleEdit={this.toggleEdit}
        />
      )
    }
  }

  toggleView = (show, irc) => {
    this.setState({ showViewModal: show, currentItem: irc })
  }

  renderViewModal() {
    const {
      translate,
      auth: { user },
    } = this.props
    const { currentItem, showViewModal } = this.state
    if (showViewModal) {
      return (
        <ViewModal
          translate={translate}
          user={user}
          currentItem={currentItem}
          toggleView={this.toggleView}
          toggleEdit={this.toggleEdit}
          toggleUpload={this.toggleUpload}
        />
      )
    }
  }

  toggleUpload = (show, file = false, noFile = false) => {
    this.setState({
      showUploadModal: show,
      csvFile: !noFile ? file : false,
      currentItem: noFile ? file : false,
    })
  }

  renderUploadModal() {
    const {
      translate,
      auth: { user },
      validateProducts,
      productsValidation,
    } = this.props
    const { currentItem, showUploadModal, csvFile } = this.state
    if (showUploadModal) {
      return (
        <UploadModal
          translate={translate}
          user={user}
          file={csvFile}
          currentItem={currentItem}
          toggleUpload={this.toggleUpload}
          validateProducts={validateProducts}
          productsValidation={productsValidation}
          onSubmit={this.onSubmit}
        />
      )
    }
  }

  toggleProcessing = (show, irc = false) => {
    this.setState({ showProcessingModal: show, currentItem: irc })
  }

  renderProcessingModal() {
    const {
      translate,
      auth: { user },
    } = this.props
    const { currentItem, showProcessingModal } = this.state
    if (showProcessingModal) {
      return (
        <ProcessingModal
          translate={translate}
          user={user}
          currentItem={currentItem}
          toggleProcessing={this.toggleProcessing}
        />
      )
    }
  }

  onFilter = (values) => {
    this.setState({ sideFilterVisible: false, filterParams: values }, () => {
      this.handleFetchIrcList()
    })
  }

  renderSideFilterForm() {
    const { translate, auth } = this.props
    const { sideFilterVisible } = this.state
    return (
      <SideFilterForm
        show={sideFilterVisible}
        closeFilter={() => this.setState({ sideFilterVisible: false })}
        onSubmit={this.onFilter}
        missionsSelectBranchs={this.state.missionsSelectBranchs}
        translate={translate}
        auth={auth}
      />
    )
  }

  validateCsv(e) {
    const { translate } = this.props
    let valid = false
    if (e.length > 0) {
      const file = e[0]
      let ext = (file.name || '').split('.')
      ext = ext[ext.length - 1].toLowerCase()
      if (ext !== 'csv') {
        this.setState({
          showErrorModal: true,
          errorModalData: {
            title: translate('error'),
            text: translate('irc.error.validate.file'),
            details: '',
            reasonText: translate('irc.file.error.type')
          }
        })
      } else if (file.size > 5 * 1024 * 1024) {
        this.setState({
          showErrorModal: true,
          errorModalData: {
            title: translate('error'),
            text: translate('irc.error.validate.file'),
            details: '',
            reasonText: translate('irc.file.error.size')
          }
        })
      } else {
        valid = true
      }
    }
    if (!valid) {
      this.setState({ fileError: true }, () => {
        this.setState({ fileError: false })
      })
    }
    return valid
  }

  renderScheduleBlockWarning() {
    const { translate } = this.props
    const {
      showScheduleBlockWarning,
      scheduleBlockMessage,
      scheduleBlockMessageHtml,
      scheduleBlockType,
      showScheduleBlockButton,
      scheduleBlockShouldRefresh,
      customTitle,
      customQuestion,
      customButton1Text,
      customButton2Text,
      scheduleBlockScrollableList
    } = this.state
    if (!showScheduleBlockWarning) return null
    return (
      <DetailedWarningModal
        translate={translate}
        message={scheduleBlockMessage}
        messageAsHtml={scheduleBlockMessageHtml}
        onClose={() => {
          this.setState({
            showScheduleBlockWarning: false,
            scheduleBlockMessageHtml: '',
            customTitle: null,
            customQuestion: null,
            customButton1Text: null,
            customButton2Text: null,
            scheduleBlockShouldRefresh: true,
            scheduleBlockScrollableList: null
          })
          if (scheduleBlockShouldRefresh) {
            this.handleFetchIrcList()
          }
        }}
        isError={scheduleBlockType === 'error'}
        showButton1={showScheduleBlockButton}
        title={customTitle}
        question={customQuestion}
        button1Text={customButton1Text || translate('irc.schedule.block.access')}
        button2Text={customButton2Text}
        onButton1Click={() => {
          browserHistory.push('/irc-schedule-block')
          this.setState({
            showScheduleBlockWarning: false,
            scheduleBlockMessageHtml: '',
            customTitle: null,
            customQuestion: null,
            customButton1Text: null,
            customButton2Text: null,
            scheduleBlockShouldRefresh: true,
            scheduleBlockScrollableList: null
          })
        }}
        scrollableList={scheduleBlockScrollableList}
      />
    )
  }

  renderErrorModal() {
    const { translate } = this.props
    const { showErrorModal, errorModalData } = this.state
    if (!showErrorModal || !errorModalData) return null
    return (
      <DetailedErrorModal
        translate={translate}
        title={errorModalData.title}
        text={errorModalData.text}
        details={errorModalData.details}
        reasonText={errorModalData.reasonText}
        reasonLabel={translate('reason.label')}
        scrollableList={errorModalData.scrollableList}
        footerText={errorModalData.footerText}
        onClose={() => this.setState({
          showErrorModal: false,
          errorModalData: null
        })}
      />
    )
  }

  render() {
    const {
      translate,
      auth: { user },
      ircList,
      pages,
      current,
      count,
      isUserMatriz
    } = this.props
    const { successModalMsg, showUploadModal, fileError } = this.state
    return (
      <>
        <div className='new-style'>
          <ContentHeader>{translate('irc.lists')}</ContentHeader>
          <div className='new-style-filter'>
            <section className='container-fluid new-upper-container'>
              <div className='col-xs-5'>
                {!showUploadModal && !fileError && isUserMatriz ? (
                  <FileInput
                    helpText={translate('irc.file.help')}
                    accept={'.csv'}
                    onChange={(e) => {
                      if (this.validateCsv(e)) {
                        this.toggleUpload(true, e[0])
                      }
                    }}
                    label={''}
                    name='file'
                  />
                ) : (
                  <div className='file-input-empty' />
                )}
              </div>
              <div className='col-xs-7'>
                <div className='float-right'>
                  {!successModalMsg && (
                    <FormModal
                      translate={translate}
                      onSubmit={this.onSubmit}
                      user={user}
                    />
                  )}
                  <Button
                    className='btn btn-secondary'
                    text={translate('mobile.filter')}
                    onClick={() => this.setState({ sideFilterVisible: true })}
                    svgIcon
                    svgComponent={<FilterIconSVG className="margin-default-svg" newDesign={false} />}
                  />
                </div>
              </div>
            </section>
          </div>
          <div className='new-style-table'>
            <Grid fluid className='no-padding'>
              <div className='outer-table new-outer-table'>
                <Tables
                  user={user}
                  translate={translate}
                  ircList={ircList}
                  handleDelete={this.handleDelete}
                  toggleEdit={this.toggleEdit}
                  toggleView={this.toggleView}
                  toggleProcessing={this.toggleProcessing}
                  toggleUpload={this.toggleUpload}
                  userMatriz={isUserMatriz}
                />
              </div>
            </Grid>
            <Row>
              <Col className='align-center margin-bottom'>
                {pages && pages > 1 ? (
                  <Pagination
                    getPage={this.handleFetchIrcList}
                    pages={pages}
                    current={current}
                    count={count}
                  />
                ) : (
                  ''
                )}
              </Col>
            </Row>
          </div>
          {this.renderSideFilterForm()}
        </div>
        {this.renderProcessingModal()}
        {this.renderViewModal()}
        {this.renderEditModal()}
        {this.renderUploadModal()}
        {this.renderScheduleBlockWarning()}
        {this.renderErrorModal()}
        {successModalMsg && (
          <SuccessModal
            t={translate}
            msg={successModalMsg}
            size='lg'
            center
            fillButton
            buttonText={translate('ok_button')}
            handleClose={() => {
              this.setState({ successModalMsg: false })
              this.handleFetchIrcList()
            }}
          />
        )}
      </>
    )
  }
}

const mapStateToProps = ({ auth, ircReducer, paginateReducer }) => ({
  productsValidation: ircReducer.productsValidation,
  ircList: ircReducer.list.records,
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
  isUserMatriz: auth.isUserMatriz
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(ircActions, dispatch)

const IrcListsTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(IrcLists)

export default connect(mapStateToProps, mapDispatchToProps)(IrcListsTranslated)
export { IrcLists }
